// extracted by mini-css-extract-plugin
export default {"image":"TopBackground_image__1dcpI"};